import React from "react"
import { useTranslation } from "react-i18next"
import SocialLinks from "./social"

const Footer = ({ data }) => {
  const { t } = useTranslation()
  return (
    <footer>
      <div className="footer">
        <p className="follow">Follow us!</p>
        <SocialLinks />
        <div className="footer__copyright">
          <div className="footer__copyright__photography">
            {t("Photo principale")} : {data.site.siteMetadata.photography.name}
          </div>
          © {new Date().getFullYear()}{" "}
          <a href={data.site.siteMetadata.author.website}>
            {data.site.siteMetadata.author.name}
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
